import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import authenticationReducer from './modules/Authentication/reducers/index';
import healthCheckReducer from './modules/HealthCheck/reducers';
import workOrderListReducer from './modules/WorkorderList/reducers/workOrderList';
import productListReducer from './modules/WorkorderList/reducers/productList';
import languageStringsReducer from './languageStringReducer';
import mapIdReducer from './modules/Map/reducers/mapId';
import mapTokenReducer from './modules/Map/reducers/mapTokenReducer';
import findServicesReducer from './modules/WorkLog/reducers/findServicesReducer';
import zendeskReducer from './modules/WorkLog/reducers/zendeskReducer';
import devicePollingMacReducer from './modules/HealthCheck/reducers/devicePollingMacReducer';
import devicePollingCustomerReducer from './modules/HealthCheck/reducers/devicePollingReducer';
import updateDevicePollingMacReducer from './modules/HealthCheck/reducers/updateDevicePollingMacReducer';
import popupReducer from './components/Popup/reducers/popupReducer';
import dayStatusReducer from './modules/Authentication/reducers/dayStatusReducer';
import serviceTypesReducer from './modules/CreateNewWorkOrder/reducers/serviceTypesReducer';
import workOrderServicesReducer from './modules/WorkLog/reducers/workOrderServicesReducer';
import followUpFormsReducer from './modules/FollowUpForms/reducers/followUpReducer';
import prevWorkOrderList from './modules/WorkorderList/reducers/prevWorkOrderList';
const allReducers = {
    authentication: authenticationReducer,
    workOrders: workOrderListReducer,
    previousWorkOrders: prevWorkOrderList,
    productList: productListReducer,
    NOB: languageStringsReducer,
    form: formReducer,
    map: mapIdReducer,
    mapToken: mapTokenReducer,
    healthCheck: healthCheckReducer,
    findServices: findServicesReducer,
    zendesk: zendeskReducer,
    devicePollingMac: devicePollingMacReducer,
    devicePollingCustomer: devicePollingCustomerReducer,
    updateDevicePollingMac: updateDevicePollingMacReducer,
    popup: popupReducer,
    dayStatus: dayStatusReducer,
    serviceTypes: serviceTypesReducer,
    workOrderServices: workOrderServicesReducer,
    followUpForms: followUpFormsReducer,
};
const appReducer = combineReducers(Object.assign({}, allReducers));
const createRootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
        state = undefined; // eslint-disable-line no-param-reassign
    }
    return appReducer(state, action);
};
export default createRootReducer;
